import React, { useEffect, useRef, useState } from 'react';

import edit from "../../../../../assets/images/edit.png";
import Trash from "../../../../../assets/images/trash.png";

import { withRFSToken } from '../../../../../Services/axios.js';
import { TRUCKORDERDETAILS, DELAWB } from '../../../../../Utils/conts';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import { jqxCookieCall } from '../../../../../Components/common/CommonFunctions.js';


const Shipment = () => {

    let storedData = localStorage.getItem('TODetails');
    if (storedData) {
        storedData = JSON.parse(storedData)
    }

    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridData, setGridData] = useState([]);

    const [filterApplied, setFilterApplied] = useState(false);
    const [showEdit, setShowEdit] = useState(false);

    useEffect(() => {
        if (isMounted.current) return;

        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);
    const gridRef = useRef(null);

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const btid = storedData?.truck_orders_id
            const ttrid = storedData?.bookingtruck_id
            const source = {
                // url: `${process.env.REACT_APP_RFS_URL}get-assigned-awbs?bookingtruck_date_id=${btid}&bookingtruck_id=${ttrid}`,
                url: `${process.env.REACT_APP_RFS_URL}truck-order-shipments?truck_orders_id=${btid}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'time', type: 'string' },
                    { name: 'flight_number_join', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'operational_truck', type: 'string' },
                    { name: 'received', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'shc', type: 'string' },
                    { name: 'commodity', type: 'string' },
                    { name: 'connection_time', type: 'string' },
                    { name: 'origin', type: 'string' },

                    { name: 'bkd', type: 'string' },
                    { name: 'colour_status', type: 'string' },
                    { name: 'connecting_flight', type: 'string' },
                    { name: 'import_export', type: 'string' },
                ],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function (column, direction) {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            let columns;

            if (storedData?.booking_type == 'E') {
                columns = [
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                        },
                        width: '6%', filterable: false,
                    },
                    {
                        text: 'Airway bill', filtertype: 'textbox', datafield: 'airway_bill', width: '10%', cellclassname: '',
                        cellclassname: (row, column, value, rowData) => {
                            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
                            if (rowData.colour_status == 'G') {
                                return "awb_green";
                            } else if (rowData.colour_status == 'R') {
                                return "awb_red";
                            } else if (rowData.colour_status == 'O') {
                                return "awb_orange";
                            } else {
                                return;
                            }
                        },
                    },
                    { text: 'Dest.', filtertype: 'textbox', datafield: 'destination', width: '5%', cellclassname: '', },
                    { text: 'CT', filtertype: 'textbox', datafield: 'connection_time', width: '9%', cellclassname: '', },
                    { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number_join', width: '9%', cellclassname: '', },
                    { text: 'Truck', filtertype: 'textbox', datafield: 'operational_truck', width: '9%', cellclassname: '', },
                    { text: 'RCS', filtertype: 'textbox', datafield: 'received', width: '9%', cellclassname: '', },
                    { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', },
                    { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', },
                    { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '5%', cellclassname: '', },
                    { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '11%', cellclassname: '', },
                    { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '11%', cellclassname: '', },

                ];
            } else {
                columns = [
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                        },
                        width: '6%', filterable: false,
                    },
                    {
                        text: 'Airway bill', filtertype: 'textbox', datafield: 'airway_bill', width: '10%', cellclassname: '',
                        cellclassname: (row, column, value, rowData) => {
                            // console.log("🚀 ~ useEffect ~ rowData:", rowData)
                            if (rowData.colour_status == 'G') {
                                return "awb_green";
                            } else if (rowData.colour_status == 'R') {
                                return "awb_red";
                            } else if (rowData.colour_status == 'O') {
                                return "awb_orange";
                            } else {
                                return;
                            }
                        },
                    },
                    { text: 'Import/Export', filtertype: 'textbox', datafield: 'import_export', width: '9%', cellclassname: '', },
                    { text: 'Connecting Flight', filtertype: 'textbox', datafield: 'connecting_flight', width: '9%', cellclassname: '', },
                    { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '9%', cellclassname: '', },
                    { text: 'Dest.', filtertype: 'textbox', datafield: 'destination', width: '9%', cellclassname: '', },
                    { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '9%', cellclassname: '', },
                    { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '9%', cellclassname: '', },
                    { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '9%', cellclassname: '', },
                    { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '9%', cellclassname: '', },

                    // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '9%', cellclassname: '', },
                    // { text: 'Flight No', filtertype: 'textbox', datafield: 'flight_number', width: '9%', cellclassname: '', },
                    // { text: 'Flight Date', filtertype: 'textbox', datafield: 'flight_date', width: '9%', cellclassname: '', },
                    // { text: 'CT', filtertype: 'textbox', datafield: 'connection_time', width: '9%', cellclassname: '', },
                ];
            }
            const nestedColumns = [
                { text: 'Pieces', datafield: 'pieces', width: '14%' },
                { text: 'Weight', datafield: 'weight', width: '14%' },
                { text: 'Length', datafield: 'length', width: '14%' },
                { text: 'Width', datafield: 'width', width: '14%' },
                { text: 'Height', datafield: 'height', width: '14%' },
                { text: 'Stackable', datafield: 'stackable', width: '14%' },
                { text: 'Rotatable', datafield: 'rotatable', width: '14%' },
            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = Array.isArray(record.package_information)
                    ? record.package_information
                    : (record.package_information ? [record.package_information] : []);
                const nestedSource = {
                    datatype: 'array',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'length', type: 'string' },
                        { name: 'width', type: 'string' },
                        { name: 'height', type: 'string' },
                        { name: 'stackable', type: 'string' },
                        { name: 'rotatable', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
                const nestedGridOptions = {
                    width: '90%',
                    pageable: false,
                    sortable: false,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i;
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);
            };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                initrowdetails: initrowdetails,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awb_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.awb_id === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awb_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awb_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awb_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }
            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                // const dataToSend = {
                //     uld_number: rowData.uld_number,
                //     type_code: rowData.type_code,
                //     serial_number: rowData.serial_number,
                //     owner_code: rowData.owner_code,
                //     condition_code: rowData.condition_code,
                //     asset_type: rowData.asset_type
                // };
                handleShow('E', rowData);
                // setEditData(dataToSend);
                setShowEdit(true);

            });
            window.$(gridRef.current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);

                handleModalOpen('G', rowData.awb_id);
            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    // loadDetails(args.uld_number);
                }
            });
        }
    }, [gridData]);

    const [show, setShow] = useState(false);
    const [addEdit, setAddEdit] = useState('');
    const [editmodalData, setEditModalData] = useState();
    const [rowId, setRowId] = useState();
    const [notArea, setNotArea] = useState();
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();
    const handleModalClose = () => { setShowModal(false); setModalData(); };
    const handleModalOpen = (area, item) => {
        setNotArea(area);
        if (area === 'G') {
            setRowId(item);
        }
        setShowModal(true);

    };
    const handleShow = (e, item) => {
        if (e == 'Assign') {
            if (gridSelect.length === 0) {
                toast.error('Please select at least one Airway Bill to reassign')
            } else {
                setShow(true);
                setAddEdit(e);
                const keysToRemove = ['Assign AWB'];
                keysToRemove.forEach(key => localStorage.removeItem(key));

                const storageData = { AWB: gridSelect, BTS: {} };
                // saveAndNavigate(action, storageData);
                localStorage.setItem(item, JSON.stringify(storageData));
            }
        } else {
            setShow(true);
            setAddEdit(e);
            setEditModalData(item);
        }
    };

    const handleConfirmation = (confirm) => {
        if (confirm) {
            if (notArea === 'G') {
                handleDeleteRow();
            }
            setShowModal(false);
        } else {
            setModalData();
        }
    };

    const handleDeleteRow = async () => {
        try {
            const res = await withRFSToken.post(DELAWB, { awb_id: rowId })
                .then(function (res) {
                    const innerData = res.data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code === 200) {
                        // fetchPalletList();
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRef.current).jqxGrid('updatebounddata');
                        }, 1);
                    }

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    const resetFilters = () => {
        window.$(gridRef).jqxGrid('clearfilters');
    };

    return (
        <>
            {!isLoading && <>
                {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                <div ref={gridRef} className='bookinggrid' ></div>
            </>
            }
        </>
    )
}

export default Shipment